import React, {
  createContext,
  useCallback,
  useContext,
  useReducer,
} from "react";

const FundItPageContext = createContext();

const initialState = {
  needInitialFetch: true,
  initializedByForcedState: false,
  paymentsEnabled: false,
  userIsSuperAdmin: false,
  hasWebsite: false,
  hasAddress: false,
  addressInUS: false,
  hasDenomination: false,
  userHasFirstName: false,
  userHasLastName: false,
  userEmailVerified: false,
  userPhoneVerified: false,
  hasMerchantAccount: false,
  canGetPayments: false,
  hasEnteredBankInfo: false,
  hasEnteredKYC: false,
  hasKYCValidationError: false,
  canGetPayouts: false,
  numberOfFunds: 0,
  termsOfService: "",
  openModalAfterUpdate: false,
  pricing: {
    creditCardPercentage: null,
    achPercentage: null,
    additionalFlatFee: null,
    isForChildNetworks: false,
    comments: null,
  },
};

const reducer = (state, action) => {
  switch (action.type) {
    case "setState": {
      return {
        ...state,
        ...action.payload,
      };
    }

    // case "setState":
    //     let newState = {...state};
    //   for (const key in action.payload) {
    //     newState[key] = action.payload[key];
    //   }
    //   return newState;

    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
};

function FundItPageProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);

  const setState = useCallback(
    (payload) => dispatch({ type: "setState", payload }),
    [dispatch]
  );

  return (
    <FundItPageContext.Provider value={{ state, dispatch, setState }}>
      {children}
    </FundItPageContext.Provider>
  );
}

function useFundItPage() {
  const context = useContext(FundItPageContext);
  if (context === undefined) {
    throw new Error(`useFundItPage must be used within a FundItPageProvider`);
  }
  return context;
}

export { FundItPageContext, FundItPageProvider, useFundItPage, initialState };
